import { UbaldoReportDTO } from '../utils/ubaldoMapper';

const UBALDO_API_URL = process.env.REACT_APP_UBALDO_API_URL || '';
const UBALDO_API_KEY = process.env.REACT_APP_UBALDO_API_KEY || '';

/**
 * Calls the Ubaldo report generation API and returns the PDF as a Blob.
 * The caller is responsible for triggering the browser download.
 */
export async function generateReportPdf(dto: UbaldoReportDTO, language: 'IT' | 'EN'): Promise<Blob> {
  if (!UBALDO_API_URL) {
    throw new Error('REACT_APP_UBALDO_API_URL is not configured');
  }
  if (!UBALDO_API_KEY) {
    throw new Error('REACT_APP_UBALDO_API_KEY is not configured');
  }

  const response = await fetch(`${UBALDO_API_URL}/api/reports/generate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-API-Key': UBALDO_API_KEY,
    },
    body: JSON.stringify(
      {
        "type": "report",
        "language": language,
        "format": "pdf",
        "data": dto
      }),
  });

  if (!response.ok) {
    const errorText = await response.text().catch(() => String(response.status));
    throw new Error(`Ubaldo API error (${response.status}): ${errorText}`);
  }

  return response.blob();
}

/**
 * Triggers a browser file download for the given Blob.
 */
export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
